<template>
    <div class="col-12 opening-hours">
        <div class="header">
            <h5>
                Opening hours
            </h5>
            <button
                class="btn btn-success waves-effect waves-light"
                type="button"
                @click="addHour"
            >
                <i class="fas fa-plus" />
            </button>
        </div>

        <div
            v-for="(hour, index) in hours"
            :key="index"
            class="row main-section"
        >
            <div class="col-3">
                <div class="form-group">
                    <label :for="`day_${index}`">Day</label>
                    <input
                        :id="`day_${index}`"
                        v-model="hour.day"
                        type="text"
                        class="form-control"
                        :class="{
                            'is-invalid': validation.$each[index].day.$error
                        }"
                        dir="auto"
                    />
                    <div class="invalid-feedback">
                        {{ getError('day', index) }}
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label :for="`open_${index}`">Open</label>
                    <input
                        :id="`open_${index}`"
                        v-model="hour.open"
                        type="time"
                        class="form-control"
                        :class="{
                            'is-invalid': validation.$each[index].open.$error
                        }"
                        dir="auto"
                    />
                    <div class="invalid-feedback">
                        {{ getError('open', index) }}
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label :for="`close_${index}`">Close</label>
                    <input
                        :id="`close_${index}`"
                        v-model="hour.close"
                        type="time"
                        class="form-control"
                        :class="{
                            'is-invalid': validation.$each[index].close.$error
                        }"
                        dir="auto"
                    />
                    <div class="invalid-feedback">
                        {{ getError('close', index) }}
                    </div>
                </div>
            </div>
            <div class="col-1 actions-column">
                <button class="action-button" @click="deleteHour(index)">
                    <i class="far fa-trash-alt" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            hours: [...this.value]
        };
    },

    watch: {
        hours: {
            handler(value) {
                this.$emit('input', value);
            },
            deep: true
        }
    },

    methods: {
        addHour() {
            this.hours = [...this.hours, {}];
        },

        deleteHour(index) {
            this.hours.splice(index, 1);
        },

        getError(key, index) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation,
                this.serverErrors,
                key,
                index
            );
        }
    }
};
</script>
